.wizard-step-main__body--framed.manage-components-step {
  padding: 1rem;
}
.wizard-step-main__body--framed.manage-components-step .components-panel--tree {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
  height: 100%;
  overflow: hidden;
  padding: 2px;
}
.wizard-step-main__body--framed.manage-components-step .components-panel--tree .tree-toolbar {
  padding-bottom: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.wizard-step-main__body--framed.manage-components-step .components-panel--tree .tree-toolbar > button:not(:last-child) {
  width: unset;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL29wdC9zcmMvc2NyaXB0L2NvbXBvbmVudHMvU2l0ZUFkbWluVmlldy9XaXphcmQvY29tcG9uZW50cy9Db21wb25lbnRTdGVwL3N1YnN0ZXBzL01hbmFnZVN0ZXAiLCJzb3VyY2VzIjpbIk1hbmFnZVN0ZXAuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOztBQUVBO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBO0VBQ0E7O0FBRUE7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi53aXphcmQtc3RlcC1tYWluX19ib2R5LS1mcmFtZWQubWFuYWdlLWNvbXBvbmVudHMtc3RlcCB7XG4gIHBhZGRpbmc6IDFyZW07XG5cbiAgLmNvbXBvbmVudHMtcGFuZWwtLXRyZWUge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IGNvbHVtbjtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGZsZXgtc3RhcnQ7XG4gICAgYWxpZ24taXRlbXM6IGZsZXgtc3RhcnQ7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICBoZWlnaHQ6IDEwMCU7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgICBwYWRkaW5nOiAycHg7XG5cbiAgICAudHJlZS10b29sYmFyIHtcbiAgICAgIHBhZGRpbmctYm90dG9tOiAxcmVtO1xuICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgICAganVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuO1xuICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcblxuICAgICAgJiA+IGJ1dHRvbjpub3QoOmxhc3QtY2hpbGQpIHtcbiAgICAgICAgd2lkdGg6IHVuc2V0O1xuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIl19 */